import { createSlotRecipe } from './runtime.js';

const breadcrumbConfig = {"name":"breadcrumb","slots":["root","list","item","link","separator","ellipsis","startIcon","endIcon"],"defaultVariants":{"size":"md"},"variantMap":{"size":["lg","md","sm"]}}

export const breadcrumb = /* @__PURE__ */ createSlotRecipe(breadcrumbConfig)